import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const getYesterday = () => {
  const d = new Date();
  d?.setDate(d?.getDate() - 1);
  return d?.toISOString()?.slice(0, 10);
};

const formatDisplayDate = (isoDate) => {
  if (!isoDate) return '';
  return new Date(`${isoDate}T00:00:00`)?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

// millLabel (single-row mode, e.g. "Shree Renuka Sugars (S-30)") vs millCount (bulk "Revert All" mode)
const RevertModal = ({ millCount, millLabel, onConfirm, onCancel }) => {
  const [targetDate, setTargetDate] = useState(getYesterday());
  const isSingle = Boolean(millLabel);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6" style={{ borderColor: '#e8ddd0' }}>
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: '#fef3c7' }}>
              <AlertTriangle size={20} style={{ color: '#d97706' }} />
            </div>
            <h3 className="text-base font-bold" style={{ color: '#1f2937' }}>
              {isSingle ? 'Revert This Rate' : 'Revert All to a Past Date'}
            </h3>
          </div>
          <button onClick={onCancel} className="p-1 rounded hover:bg-gray-100">
            <X size={16} style={{ color: '#6b7280' }} />
          </button>
        </div>

        <label className="block text-xs font-semibold mb-1.5" style={{ color: '#6b7280' }}>
          Revert to rate approved on or before
        </label>
        <input
          type="date"
          value={targetDate}
          max={getYesterday()}
          onChange={e => setTargetDate(e?.target?.value)}
          className="w-full mb-4 rounded-lg border px-3 py-2 text-sm outline-none"
          style={{ borderColor: '#e8ddd0', color: '#1f2937' }}
        />

        <p className="text-sm mb-5 leading-relaxed" style={{ color: '#4b5563' }}>
          {isSingle ? (
            <>This will revert <strong>{millLabel}</strong>'s rate to its approved value as of <strong>{formatDisplayDate(targetDate)}</strong>.</>
          ) : (
            <>This will revert rates for <strong>{millCount} mill{millCount !== 1 ? 's' : ''}</strong> to their approved value as of <strong>{formatDisplayDate(targetDate)}</strong>.</>
          )}{' '}
          This action <strong>creates new entries</strong> and does not delete history. Confirm?
        </p>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2.5 rounded-lg border text-sm font-semibold transition hover:bg-gray-50"
            style={{ borderColor: '#e8ddd0', color: '#4b5563' }}
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(targetDate)}
            disabled={!targetDate}
            className="flex-1 px-4 py-2.5 rounded-lg text-sm font-semibold text-white transition hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: '#d97706' }}
          >
            Confirm Revert
          </button>
        </div>
      </div>
    </div>
  );
};

export default RevertModal;
